import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Row from 'react-bootstrap/Row';
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import { Container } from "react-bootstrap";
// ************** Datatable
import 'datatables.net-dt/css/dataTables.dataTables.css';  // Estilos de DataTable
import 'datatables.net';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import 'bootstrap-icons/font/bootstrap-icons.css';

import Modal from 'react-bootstrap/Modal';
import Relacion from './relacionPersonasProyecto';
import Spinner from "react-bootstrap/Spinner";

import TipoDetalle from "./modal/tipoDetalle";

DataTable.use(DT);

const CRUDproyectos = ({usuario, apiUrl}) => {
    const [arrPersonasProyecto, setArrPersonasProyecto] = useState([])
    const [proyectos, setProyectos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    //
    const dateFechaActual = new Date();
    dateFechaActual.setHours(0, 0, 0, 0);
    // **** Modal
    const [rowSelected, setRowSelected] = useState();
    const [idProyectoSelected, setIdProyectoSelected] = useState(0);
    const [nombreProyectoSelected, setNombreProyectoSelected] = useState(0);
    const [fechaInicioSelected, setFechaInicioSelected] = useState();
    const [fechaFinSelected, setFechaFinSelected] = useState();
    const [presupuestoSelected, setPresupuestoSelected] = useState(0);
    const [saldoSelected, setSaldoSelected] = useState(0);
    const [estatusSelected, setEstatusSelected] = useState(0);
    const [horasSemanaSelected, setHorasSemanaSelected] = useState(0);
    const [horasDiaSelected, setHorasDiaSelected] = useState(0);
    const [idUsuarioResponsableSelected, setidUsuarioResponsableSelected] = useState(0);
    //
    const [showModal, setShowModal] = useState(false);
    const [showModalRelacion, setShowModalRelacion] = useState(false);
    const [showModalDetalle, setShowModalDetalle] = useState(false);
    const [showModalEliminar, setShowModalEliminar] = useState(false);
    const [showRelacionPersonasProyectos, setShowRelacionPersonasProyectos] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);

    const handleCloseModal = () => {
        setArrPersonasProyecto([]);
        setShowModal(false);
    }

    const handleCloseModalRelacion = () => {
        setArrPersonasProyecto([]);
        setShowModalRelacion(false);
    }    
    //
    const handleShowModal = (IDPROYECTO, NOMBREPROYECTO, FECHAINICIO, FECHAFIN, PRESUPUESTO, SALDO, ESTATUS, IDUSUARIORESPONSABLE, HORASSEMANA, HORASDIA) => {
        setIdProyectoSelected(IDPROYECTO)
        setNombreProyectoSelected(NOMBREPROYECTO)
        setFechaInicioSelected(FECHAINICIO)
        setFechaFinSelected(FECHAFIN)
        setPresupuestoSelected(PRESUPUESTO)
        setSaldoSelected(SALDO)
        setEstatusSelected(ESTATUS)
        setidUsuarioResponsableSelected(IDUSUARIORESPONSABLE)
        setHorasSemanaSelected(HORASSEMANA)
        setHorasDiaSelected(HORASDIA)
        setShowModal(true);
        if(IDPROYECTO!==-1) {
            obtenerPersonasProyecto(IDPROYECTO);
        }
    }
    /////
    const handleShowModalRelacion = (IDPROYECTO, NOMBREPROYECTO) => {
        setIdProyectoSelected(IDPROYECTO)
        setNombreProyectoSelected(NOMBREPROYECTO)
        obtenerPersonasProyecto(IDPROYECTO);
        setShowModalRelacion(true);
    }

    const obtenerProyectos = ()=>{
        axios.post(`${apiUrl}/proyecto/obtenProyectos?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse) => {
                setProyectos(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error: ' + error.response.data)
            });
    }
    
    const obtenerUsuarios = () => {
        axios.post(`${apiUrl}/usuario/obtenUsuarios?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse)=>{
                setUsuarios(objResponse.data.response);
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de usuarios: ' + error.response.data)
            })
    }

    const obtenerPersonasProyecto = (paramIDPROYECTO) => {
        setShowSpinner(true);
        axios.post(`${apiUrl}/personasProyecto/obtenPersonasProyecto?token=${sessionStorage.getItem('token')}`, 
            {
                idProyecto: paramIDPROYECTO
            })
            .then((objResponse)=>{
                setArrPersonasProyecto(objResponse.data.response)
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de personas: ' + error.response.data)
            })
            .finally(()=>{
                setShowSpinner(false);
            })
    }

    const guardarProyecto = () => {
        axios.post(`${apiUrl}/proyecto/guardarProyecto?token=${sessionStorage.getItem('token')}`, 
            {
                IDPROYECTO: idProyectoSelected, 
                NOMBREPROYECTO: nombreProyectoSelected, 
                INICIO: fechaInicioSelected, 
                FIN: fechaFinSelected, 
                PRESUPUESTO: presupuestoSelected,
                ESTATUS: estatusSelected, 
                IDUSUARIORESPONSABLE: idUsuarioResponsableSelected,
                HORASSEMANA: horasSemanaSelected, 
                HORASDIA: horasDiaSelected,
                IDUSUARIOFUC: usuario.IDUSUARIO
            })
            .then((objResponse)=>{
                setArrPersonasProyecto([])
                handleCloseModal()
                obtenerProyectos()
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de personas: ' + error.response.data)
            })
    }

    const guardarRelacionPersonas = ()=>{
        axios.post(`${apiUrl}/personasProyecto/guardarRelacionPersonas?token=${sessionStorage.getItem('token')}`, 
            {
                IDPROYECTO: idProyectoSelected, 
                NOMBREPROYECTO: nombreProyectoSelected,
                RelacionPersonas: arrPersonasProyecto,
                IDUSUARIOFUC: usuario.IDUSUARIO
            })
            .then((objResponse)=>{
                setArrPersonasProyecto([])
                handleCloseModalRelacion()
                obtenerProyectos()
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de personas: ' + error.response.data)
            })
    }

    const actualizarSaldo = () => {
        axios.post(`${apiUrl}/proyecto/actualizaSaldoProyecto?token=${sessionStorage.getItem('token')}`, 
            {
                IDPROYECTO: idProyectoSelected,
                IDUSUARIOMODIFICACION: usuario.IDUSUARIO
            })
            .then((objResponse)=>{
                setSaldoSelected(objResponse.data.result.nuevoSaldo)
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de personas: ' + error.response.data)
            })
    }

    const eliminaProyecto = ()=>{
        axios.post(`${apiUrl}/proyecto/eliminarProyecto?token=${sessionStorage.getItem('token')}`,{
            idProyecto: idProyectoSelected,
            IDUSUARIOELIMINACION: usuario.IDUSUARIO
        })
        .then((objResponse)=>{
            console.log(objResponse);
            setShowModalEliminar(false);
            obtenerProyectos();
        })
        .catch((error)=>{
            alert('hubo un error en la eliminación de proyecto: ' + error.response.data)
        })
    }

    const soloNumeros = (event) => {
        // La tecla debe de ser carácter válido
        if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Tab') {
            event.preventDefault();
        }
    }

    const columns = [
        { data: 'IDPROYECTO', with: "10%"},
        { data: 'NOMBREPROYECTO'},
        { data: 'FECHAINICIO', with: "10%"},
        { data: 'FECHAFIN', with: "10%"},
        { data: 'PRESUPUESTO', visible: false},
        { data: 'SALDO', visible: false},
        { data: 'ESTATUS', visible: false},
        { data: 'IDUSUARIORESPONSABLE', visible: false},
        { data: 'NOMBREUSUARIORESPONSABLE', visible: false},
        { title: 'Opciones', with: "10%"},
    ];

    const languageOpt = {
        info: 'Mostrando página _PAGE_ de _PAGES_',
        infoFiltered: '(filtrados de un total de _MAX_ encontrados)',
        lengthMenu: 'Mostrando _MENU_ registros por página',
        zeroRecords: 'Cero registros encontrados con los filtros seleccionados',
        search: 'Buscar',
        infoEmpty: 'No se encontraron',
        emptyTable: 'Tabla vacía (sin registros)'
    }
    
    const options = {
        order: [[0, 'desc']], // Indica que la primera columna (índice 0) se ordene de manera descendente
        columnsDefs: [
            {
                //targets: 1, // Índice de la columna a la que le queremos dar ancho
                //width: '100%' // El ancho deseado para esa columna
            },
            {
                //targets: [9],
                //width: '100px',
            }
        ],
        language: languageOpt,
        responsive: true
    };

    useEffect(()=>{
        obtenerProyectos();
        obtenerUsuarios();
    },[]);

    const handleAgregarRelacionPersonaProyecto = (paramUsuario, paramUsuarioNombre, paramSupervisor, paramSupervisorNombre) => {
        const nuevoArreglo = [...arrPersonasProyecto, 
            {
                idPersonaProyecto: -1,
                usuario: paramUsuario,
                usuarioNombre: paramUsuarioNombre,
                supervisor: paramSupervisor,
                supervisorNombre: paramSupervisorNombre,
                activo: 1
            }
        ];
        setArrPersonasProyecto(nuevoArreglo);
        setShowRelacionPersonasProyectos(false);
    }

    const handleShowRelacionPersonasProyectos = () => {
        if(showRelacionPersonasProyectos) {
            setShowRelacionPersonasProyectos(false);
        }
        else {
            //
            setShowRelacionPersonasProyectos(true);
        }
    }

    const handleCancelaRelacion = (index) => {
        arrPersonasProyecto.splice(index, 1);
        const nuevoArreglo = [...arrPersonasProyecto];
        setArrPersonasProyecto(nuevoArreglo);
    }

    const handleShowModalDetalle = (row) => {
        setShowModalDetalle(true);
        setRowSelected(row)
    }

    const handleCloseModalDetalle = ()=>{

        setShowModalDetalle(false);
    }

    const handleShowModalEliminar = (row, IDPROYECTO) => {
        setShowModalEliminar(true);
        setRowSelected(row)
        setIdProyectoSelected(IDPROYECTO)
    }
    
    const handleCloseModalEliminar = (row) => {
        setShowModalEliminar(false);
    }

    return (
        <div>
            {/* 
                Modal para detalle de proyecto
            */}
            <Modal show={showModalDetalle} onHide={handleCloseModalDetalle} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Detalle proyecto
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TipoDetalle
                        row={rowSelected}
                    >
                    </TipoDetalle>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalDetalle}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* 
                Modal para eliminar proyecto
            */}
            <Modal show={showModalEliminar} onHide={handleCloseModalEliminar} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        ¿Está seguro de eliminar el proyecto?
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TipoDetalle
                        row={rowSelected}
                    >
                    </TipoDetalle>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalEliminar}>
                        Close
                    </Button>
                    <Button 
                        variant="danger" 
                        onClick={eliminaProyecto}
                    >
                        Eliminar proyecto
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* 
                Modal para guardar (crear/actualizar) de proyecto
            */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Actualizar proyecto
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive>
                        <tbody>
                            <tr>
                                <td width="50%">idProyecto</td>
                                <td width="50%">{idProyectoSelected}</td>
                            </tr>
                            <tr>
                                <td>Nombre proyecto</td>
                                <td>
                                    <Form.Control value={nombreProyectoSelected} onChange={(event)=>{ setNombreProyectoSelected(event.target.value) }}></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>Fecha inicio</td>
                                <td>
                                    <Form.Control 
                                        type="date"
                                        value={fechaInicioSelected}
                                        onChange={(event)=>{ setFechaInicioSelected(event.target.value) }}
                                    ></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>Fecha fin</td>
                                <td>
                                    <Form.Control 
                                        type="date"
                                        value={fechaFinSelected}
                                        onChange={(event)=>{ setFechaFinSelected(event.target.value) }}
                                    ></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>Presupuesto</td>
                                <td>
                                    <Form.Control 
                                        type="number" 
                                        value={presupuestoSelected} 
                                        onKeyDown={(event) => { soloNumeros(event) }}
                                        onChange={(event)=>{ setPresupuestoSelected(event.target.value) }}

                                    ></Form.Control>
                                </td>
                            </tr>
                            {
                                ( idProyectoSelected !== -1) ?
                                <tr>
                                    <td>Saldo</td>
                                    <td>
                                        <Row>
                                            <Col>
                                                <Button 
                                                    variant="success" 
                                                    size="sm"
                                                    onClick={actualizarSaldo}
                                                >
                                                    Actualizar saldo
                                                </Button>
                                            </Col>
                                            <Col>
                                                { saldoSelected }
                                            </Col>
                                        </Row>
                                    </td>
                                </tr>
                                : ''
                            }
                            
                            <tr>
                                <td>Estatus</td>
                                <td>
                                    <Form.Select 
                                        value={estatusSelected}
                                        onChange={(event)=>{setEstatusSelected(event.target.value)}}
                                    >
                                        <option key={'opt_proyecto_estatus1'} value="No iniciado">No iniciado</option>
                                        <option key={'opt_proyecto_estatus2'} value="En proceso">En proceso</option>
                                        <option key={'opt_proyecto_estatus3'} value="En pausa">En pausa</option>
                                        <option key={'opt_proyecto_estatus4'} value="Completado">Completado</option>
                                        <option key={'opt_proyecto_estatus5'} value="Cancelado">Cancelado</option>
                                    </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <td>Usuario Responsable</td>
                                <td>
                                    <Form.Select
                                        value={idUsuarioResponsableSelected}
                                        onChange={(event)=>{
                                            setidUsuarioResponsableSelected(event.target.value)
                                        }}
                                    >
                                        <option key="">--- Escoge un usuario responsable ---</option>
                                        {
                                            usuarios.map(usuario=>
                                                <option 
                                                    key={'opt_usuario'+usuario.IDUSUARIO} 
                                                    value={usuario.IDUSUARIO}
                                                >
                                                    {usuario.NOMBREUSUARIO} [{usuario.PUESTO}]
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Horas por semana
                                </td>
                                <td>
                                    <Form.Control 
                                        type="number" 
                                        value={horasSemanaSelected}
                                        onKeyDown={(event) => { soloNumeros(event) }}
                                        onChange={(event)=>{
                                            setHorasSemanaSelected(event.target.value)
                                        }}
                                    ></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Horas por dia
                                </td>
                                <td>
                                    <Form.Control 
                                        type="number" 
                                        value={horasDiaSelected}
                                        onKeyDown={(event) => { soloNumeros(event) }}
                                        onChange={(event)=>{
                                            setHorasDiaSelected(event.target.value)
                                        }}
                                    ></Form.Control>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button 
                        variant="success" 
                        onClick={guardarProyecto}
                    >
                        Actualizar proyecto
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* 
                Modal para mostrar las relaciones del proyecto con las personas
            */}
            <Modal show={showModalRelacion} onHide={handleCloseModalRelacion} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Actualizar relación de personas
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Colaborador</th>
                                <th>Supervisor del colaborador</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={"trRelacion0"}></tr>
                            {
                                (showSpinner) ?
                                <tr>
                                    <td colSpan="2">
                                        <Spinner animation="border" role="status">
                                        </Spinner>
                                    </td>
                                </tr>
                                :
                                    (arrPersonasProyecto.length > 0) ?
                                    arrPersonasProyecto.map((relacion, index)=>{
                                        return(
                                            <tr key={"trRelacion"+index}>
                                                <td>{relacion.usuarioNombre}</td>
                                                <td>{relacion.supervisorNombre}</td>
                                                <td>
                                                    <i className="btn btn-md btn-danger bi bi-x-square-fill" onClick={()=>{
                                                        handleCancelaRelacion(index);
                                                    }}></i>
                                                </td>
                                            </tr>
                                        )})
                                    : 
                                    <tr>
                                        <td colSpan="2" style={{textAlign: 'center'}}>
                                            Aún no hay relaciones de trabajadores
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                    <div className="justify-content-center">
                        <Button variant="primary" onClick={handleShowRelacionPersonasProyectos}>
                            <i className="bi bi-plus-square-fill"></i>
                        </Button>
                    </div>
                    {
                        (showRelacionPersonasProyectos) ?
                            <Relacion 
                                arrPersonas={usuarios} 
                                handleGuardarRelacionPersonaProyecto={handleAgregarRelacionPersonaProyecto}
                            >
                            </Relacion>
                        : ''
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalRelacion}>
                        Close
                    </Button>
                    <Button 
                        variant="success" 
                        onClick={guardarRelacionPersonas}
                    >
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
            <h3 style={{textAlign: 'center'}}>ADMINISTRACIÓN DE PROYECTOS</h3>
            <Container>
                <Row style={{paddingTop: '1em', alignItems: 'right'}} className="justify-content-md-center">
                    <Col>
                        Agregar proyecto 
                        <i 
                            onClick={()=>{
                                handleShowModal(-1, '', dateFechaActual, dateFechaActual, 0, 0, 'Activo', usuario.IDUSUARIO, 40, 8)
                            }} 
                            className="btn btn-success btn-sm bi bi-plus-square"></i>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DataTable
                            columns={columns} 
                            data={proyectos}  
                            className="display"
                            options={options}
                            responsive={true}
                            slots={{
                                9: (data, row) => (
                                    <div>
                                        {/* 
                                            **** ver detalle proyecto
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Ver detalle </strong> proyecto.
                                                </Tooltip>
                                            }
                                        >
                                            
                                            <Button 
                                                className="btn-default btn-sm bi bi-search"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModalDetalle(row)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** Editar proyecto
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Editar </strong> proyecto.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-warning btn-sm bi bi-pencil-square"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModal(row.IDPROYECTO, row.NOMBREPROYECTO, row.INICIO, row.FIN, 
                                                        row.PRESUPUESTO, row.SALDO, row.ESTATUS, row.IDUSUARIORESPONSABLE, row.HORASSEMANA, row.HORASDIA)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** Eliminar proyecto
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Eliminar</strong> proyecto.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-danger btn-sm bi bi-x-square-fill"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModalEliminar(row, row.IDPROYECTO)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** Editar relaciones proyecto
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Editar relación</strong> proyecto.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-success btn-sm bi bi-people-fill"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModalRelacion(row.IDPROYECTO, row.NOMBREPROYECTO);
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                )
                            }}
                        >
                            <thead>
                                <tr>
                                    <th className="dt-orderable-asc">IDPROYECTO</th>
                                    <th>NOMBREPROYECTO</th>
                                    <th>FECHAINICIO</th>
                                    <th>FECHAFIN</th>
                                </tr>
                            </thead>
                        </DataTable>
                    </Col>
                </Row>    
            </Container>
            
        </div>
    )
}

export default CRUDproyectos;